import React, { Component, createRef, forwardRef  } from "react";
import FJResourceCommon from 'fj-components/FJResourceView'
import FJImage from "fj-components/FJImage";
import styles from './FJresourcesElementCommon.module.less';
import $ from 'jquery';
import InlineSVG from "react-inlinesvg";
import dynamicElementSvg from '../../../icon/dynamic-element.svg';
import cppyright from '../../../icon/copyright.svg';
import FJDropDown from "fj-components/FJDropDown/FJDropDown";
import FJConfig from "../../../config/FJConfig";
import classNames from 'classnames'

function CopyIconss(props) {
	return <div className={styles.copyright_box} ref={props.forwardRef}>
		<InlineSVG src={cppyright}/>
	</div>
}

let CopyIcon = forwardRef((props, ref) => (
	<CopyIconss {...props} forwardRef={ref}/>
))

class FJResourcesElementCommon extends Component {

	constructor(props) {
		super(props);

		this.state = {
			thumbnailStatus: 'error',
			disabledMouseEvent: true
		};
		this._resourceCommon = createRef();
		this._videoBox = createRef();
	}

	_cursorPoint = null;  // 开始拖动时的鼠标位置
	_isDragStart = false; // 是否经历了开始拖动
	_cursorPointInCloneNode = null; // 拖动时鼠标相对于节点的位置
	_cloneNode = null;   // 跟随鼠标移动的节点
	_video = null;


	/**
	 * @description 显示隐藏
	 * @param toggle
	 * @private
	 */
	_disableMouseEvent = (toggle) => {
		this.setState({
			disabledMouseEvent: toggle,
		});
	};

	/**
	 * @description 点击添加
	 * @private
	 */
	_onAddClick = () => {
	  let {onAddClick, type, id, fromType} = this.props;
		if (onAddClick) {
			onAddClick(id, type, fromType);
		}
	};

	/**
	 * @description 选中
	 * @private
	 */
	_onMouseUp = () => {
		this.props.selectMedia(this.props.id, 2, 0);
	};

	/**
	 * @description 鼠标移动到素材的区域
	 * @private
	 */
	_onMouseEnter = () => {
		if (this.state.thumbnailStatus !== 'error' && this.props.url) {
			this._video = document.createElement('video');
			this._video.src = this.props.url;
			this._video.loop = true;
			this._video.autoplay = true;
			$(this._video).addClass(styles.video);
			this._videoBox.current.appendChild(this._video);
		}
	};

	/**
	 * @description 鼠标离开素材的区域
	 * @private
	 */
	_onMouseLeave = () => {
		$(this._videoBox.current).empty();
		this._video = null;
	};

	/**
	 * @description 设置缩略图的加载状态
	 * @param status
	 * @private
	 */
	_setImgLoadStatus = (status) => {
		this.setState({
			thumbnailStatus: status
		}, () => {
			$(this.placeholder).hide()
		});
	};

	/**
	 * @description 拖动
	 * @param e
	 * @param eventType
	 * @private
	 */
	_onDrag = (e, eventType) => {

		if (this.state.thumbnailStatus === 'error') {
			return
		}

		let point = {
			x: e.clientX,
			y: e.clientY,
		};

		switch (eventType) {
			case 'start': {
				this.props.selectMedia(this.props.id, 2, 0);
				this._recordPoint(e);
				this._isDragStart = true;

				let {left, top} = this._resourceCommon.current.mediaEle.current.getBoundingClientRect();
				this._cursorPointInCloneNode = {
					x: point.x - left,
					y: point.y - top,
				};
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);

				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				}

				break;
			}
			case 'change':
				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				} else {
					this._updateContentCloneNode(point, this._cursorPointInCloneNode);
				}
				break;
			case 'end':
				this._isDragStart = false;
				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				}
				this._removeContentCloneNode();
				break;
			default:
		}
	};

	_doMediaFrag = (e, point, eventType) => {
		this.props.onMediaDrag(e, {
			id: this.props.id,
			type: this.props.type,
      fromType: this.props.fromType,
			eventType: eventType
		}, (type) => {
			if (type === 'delete') {
				this._removeContentCloneNode();
			} else if (type === 'create') {
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);
			} else if (type === 'continue') {
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);
			}
		});
	};

	/**
	 * @description 记录当前鼠标位置
	 * @param e
	 */
	_recordPoint = (e) => {
		this._cursorPoint = {
			x: e.clientX,
			y: e.clientY,
		}
	};

	/**
	 * @description 渲染随着鼠标拖动的div
	 * @param {Object} point
	 * @param {number} point.x
	 * @param {number} point.y
	 * @param {Object} offsetPoint
	 * @param {number} offsetPoint.x
	 * @param {number} offsetPoint.y
	 */
	_updateContentCloneNode = (point, offsetPoint) => {
		this._cloneNode = this._cloneNode || document.createElement('div');
		if (!$(this._cloneNode).html()) {
			this._cloneNode.appendChild(this._getDragNode());
		}
		document.body.appendChild(this._cloneNode);
		$(this._cloneNode).css({
			visibility: 'visible',
			position: 'fixed',
			bottom: 'inherit',
      left: point.x - offsetPoint.x,
      top: point.y - offsetPoint.y,
      width: this.props.width,
      cursor: 'move',
      zIndex: FJConfig.mediaDragZindex,
      opacity: .8,
		});
	};

	/**
	 * @description 得到拖动时候显示的div
	 * @returns {HTMLDivElement}
	 * @private
	 */
	_getDragNode = () => {
		let node = document.createElement('div');
		let imgNode = new Image();
		imgNode.src= this.props.thumbnail;
		imgNode.draggable = false;
		$(node).append(imgNode);
		$(node).addClass(styles.drag_other_img);
		$(node).css({
			width: this.props.width,
			height: this.props.height,
			background: 'rgba(242, 243, 247, 1)'
		});
		return node;
	};

	/**
	 * @description 删除添加的随着鼠标拖动的div
	 */
	_removeContentCloneNode = () => {
		if (this._cloneNode && this._cloneNode.parentNode) {
			this._cloneNode.parentNode.removeChild(this._cloneNode);
			this._cloneNode = null;
		}
	};

	render() {
		let {
			width,
			height,
			marginRight,
			marginBottom,
			isChoose,
			thumbnail,
			hasName, // 是否显示名称
			name,
			addIconToolTip,
			classes,
      contentClassName,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			type,
			authorItem = {},
			marginLeft,
			marginTop
		} = this.props;

		let authorUrl = `@${authorItem.author} / Lottiefiles`;

		return (
			<FJResourceCommon width={width}
			                  height={height}
			                  marginRight={marginRight}
			                  marginBottom={marginBottom}
			                  ref={this._resourceCommon}
			                  hasAddBtn={this.state.thumbnailStatus !== 'error'}
			                  isCanShowHover
			                  isChoose={isChoose}
			                  hasName={hasName}
			                  name={name}
			                  fileText={name}
			                  onAddClick={this._onAddClick}
			                  onDrag={this._onDrag}
			                  onMouseUp={this._onMouseUp}
			                  onMouseEnter={this._onMouseEnter}
			                  onMouseLeave={this._onMouseLeave}
			                  addIconToolTip={addIconToolTip}
			                  classes={classes}
			                  allTooltip={allTooltip}
			                  toggleTooltip={toggleTooltip}
			                  oneTooltip={oneTooltip}
												marginLeft={marginLeft}
			                  className={styles.copy_outer_box}
												marginTop={marginTop}

			>
				<div className={styles.placeholder} ref={(ele) => {
					this.placeholder = ele
				}}/>
				<div className={classNames(styles.content, contentClassName) }>
					<FJImage url={thumbnail} setImgLoadStatus={this._setImgLoadStatus} refreshClassName={classes.refresh} />
					<div ref={this._videoBox} className={styles.video_box} />
					{
						type === 'WIDGET' ? <div className={styles.dynamic_box}>
							<InlineSVG src={dynamicElementSvg}/>
						</div> : null
					}
					{
						authorItem.author && (
							<FJDropDown overlay={
								<div className={styles.lottieInfo}>
									<span className={styles.lottieInfoText}>{authorItem.localName}</span>
									<a target="_blank" href={authorItem.lottieUrl} className={styles.lottieInfoALabel}>
										{authorUrl}
									</a>
								</div>
							}
													zIndex={22}
													canTriggerActive
													hasArrow={false}
													ref={this.dropDown}
													couldEventHide={this.state.disabledMouseEvent}
													hideEvent="screenMediaList"
													placement='FlexClipRight'
							>
								<CopyIcon />
							</FJDropDown>
						)
					}
				</div>
			</FJResourceCommon>
		)
	}

}


export default FJResourcesElementCommon;